"use client";

import * as React from "react";
import { I18nProvider } from "@lingui/react";
import { i18n } from "@lingui/core";
import type { Messages } from "@lingui/core";

export function LinguiClientProvider({
  children,
  initialLocale,
  initialMessages,
}: {
  children: React.ReactNode;
  initialLocale: string;
  initialMessages: Messages;
}) {
  // Activate synchronously so `t` macro calls in children use the correct locale
  // on the very first render after a language switch, not just after the effect.
  if (i18n.locale !== initialLocale) {
    i18n.load(initialLocale, initialMessages);
    i18n.activate(initialLocale);
  }

  React.useEffect(() => {
    i18n.load(initialLocale, initialMessages);
    i18n.activate(initialLocale);
  }, [initialLocale, initialMessages]);

  // key forces a remount of the entire child tree when the locale changes,
  // so `t` macro calls pick up the new locale.
  return (
    <I18nProvider i18n={i18n} key={initialLocale}>
      {children}
    </I18nProvider>
  );
}
